module.exports = __webpack_public_path__ + "img/tablet-neck-9_28x588.d9931295.png";